import { Injectable } from '@angular/core';
import { CustomProductSearchPage, CustomSearchCriteria } from '@catalog/const';
import { Observable } from 'rxjs';
import { OccSearchService } from './occ-search.service';

@Injectable({
  providedIn: 'root',
})
export class OccFacetsService {
  constructor(private occSearchService: OccSearchService) {}

  loadProductCount(
    queryParams: CustomSearchCriteria,
  ): Observable<Pick<CustomProductSearchPage, 'currentQuery' | 'pagination'>> {
    return this.occSearchService.loadSearchProduct({
      ...queryParams,
      fields: 'pagination',
      pageSize: 1,
    } as any);
  }

  loadCategoryCode(
    queryParams: CustomSearchCriteria['facets'],
  ): Observable<Pick<CustomProductSearchPage, 'facets' | 'breadcrumbs'>> {
    return this.occSearchService.loadSearchProduct({
      fields: 'breadcrumbs',
      facets: `allCategories:${queryParams}`,
      pageSize: 0,
    } as any);
  }
}
